const placeContent = {
    name: "place-content",
    path: "/place-content",
    title: "place-content",
    description: "Utilities for controlling how rows and columns are aligned in a grid container (shorthand for align-content and justify-content).",
    value: {
        "place-content": {
            "place-content-center": "center",
            "place-content-center-safe": "safe center",
            "place-content-stretch": "stretch",
            "place-content-normal": "normal",
            "place-content-baseline": "baseline",
            "place-content-end-safe": "safe flex-end",
            "place-content-baseline-last": "last baseline",
            "place-content-start": "flex-start",
            "place-content-end": "flex-end",
            "place-content-between": "space-between",
            "place-content-around": "space-around",
            "place-content-evenly": "space-evenly",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="grid grid-rows-3 grid-columns-3 h-64 place-content-center gap-4">
  <div class="bg-color-pink-500 text-white p-2">01</div>
  <div class="bg-color-pink-500 text-white p-2">02</div>
  <div class="bg-color-pink-500 text-white p-2">03</div>
  <div class="bg-color-pink-500 text-white p-2">04</div>
  <div class="bg-color-pink-500 text-white p-2">05</div>
  <div class="bg-color-pink-500 text-white p-2">06</div>
</div>

<div class="grid grid-rows-3 grid-columns-3 h-64 place-content-between gap-4 mt-6">
  <div class="bg-color-pink-500 text-white p-2">01</div>
  <div class="bg-color-pink-500 text-white p-2">02</div>
  <div class="bg-color-pink-500 text-white p-2">03</div>
  <div class="bg-color-pink-500 text-white p-2">04</div>
  <div class="bg-color-pink-500 text-white p-2">05</div>
  <div class="bg-color-pink-500 text-white p-2">06</div>
</div>

<div class="grid grid-rows-3 grid-columns-3 h-64 place-content-stretch gap-4 mt-6">
  <div class="bg-color-pink-500 text-white p-2">01</div>
  <div class="bg-color-pink-500 text-white p-2">02</div>
  <div class="bg-color-pink-500 text-white p-2">03</div>
  <div class="bg-color-pink-500 text-white p-2">04</div>
  <div class="bg-color-pink-500 text-white p-2">05</div>
  <div class="bg-color-pink-500 text-white p-2">06</div>
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">place-content-*</code> utilities to control how rows and columns are aligned in a grid container (shorthand for align-content and justify-content).
            </p>
            <div class="space-y-10">
                <div>
                    <small class="text-center block mb-4">place-content-center</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-64 gap-4 place-content-center font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">02</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">03</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">04</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">05</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">06</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">place-content-between</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-64 gap-4 place-content-between font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">02</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">03</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">04</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">05</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">06</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">place-content-stretch</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-64 gap-4 place-content-stretch font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">02</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">03</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">04</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">05</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">06</div>
                        </div>
                    </div>
                </div>
            </div>
            `
        },
    ]
};

export default placeContent;

<div class="space-y-10">
                <div>
                    <small class="text-center block mb-4">place-content-center</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-64 gap-4 place-content-center font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">02</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">03</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">04</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">05</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">06</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">place-content-between</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-64 gap-4 place-content-between font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">02</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">03</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">04</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">05</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">06</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">place-content-stretch</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-64 gap-4 place-content-stretch font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">02</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">03</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">04</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">05</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center rounded-lg">06</div>
                        </div>
                    </div>
                </div>
            </div>